const toLowerAndStrip = (text: string) => text && text.toLowerCase().replace(/\s/g, '');
const firstCharToUpperCase = (text: string) => text.charAt(0).toUpperCase() + text.slice(1);

export {
  toLowerAndStrip,
  firstCharToUpperCase,
};
